var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        modalName: _vm.modalName,
        modalNameShort: "cert",
        hasHeader: true,
        hasFooter: true,
        modalPrintContent: _vm.printContent,
        onClose: _vm.close,
        onShow: _vm.getData,
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c("i", { staticClass: "uk-icon-book" }),
        _vm._v(_vm._s(_vm.modalTitle)),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { id: "certificates-modal--loading" },
        },
        [
          _c("i", { staticClass: "uk-icon-spinner uk-icon-spin" }),
          _vm._v("Загрузка"),
        ]
      ),
      _vm.certificates && !_vm.loading
        ? _c(
            "div",
            { ref: "print", attrs: { id: "certificates-modal--data" } },
            [
              _c("span", { staticClass: "header" }, [
                _vm._v(
                  "Является заявителем следующих " +
                    _vm._s(
                      _vm.cert_type == "cert"
                        ? "сертификатов"
                        : _vm.cert_type == "decl"
                        ? "деклараций"
                        : "сертификатов и деклараций"
                    ) +
                    ":"
                ),
              ]),
              _vm._l(_vm.certificates, function (item, item_num) {
                return [
                  _c("div", { staticClass: "cert-block" }, [
                    _c("p", { staticClass: "cert_title" }, [
                      _c("span", { staticClass: "reg_number" }, [
                        _vm._v(_vm._s(item.reg_number)),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "status_title",
                          style: "color: " + _vm.statusColors(item.status),
                        },
                        [_vm._v(_vm._s(item.status))]
                      ),
                    ]),
                    _c("p", { staticClass: "status_type" }, [
                      _c("b", [_vm._v(_vm._s(item.type_name))]),
                    ]),
                    item.product_name
                      ? _c("p", { staticClass: "product_name" }, [
                          _c("b", [_vm._v("Продукт (изделие):")]),
                          _vm._v(" " + _vm._s(item.product_name)),
                        ])
                      : _vm._e(),
                    item.date_start
                      ? _c("p", { staticClass: "srok" }, [
                          _c("b", [_vm._v("Срок:")]),
                          _vm._v(
                            " с " +
                              _vm._s(_vm.date_format(item.date_start)) +
                              " " +
                              _vm._s(
                                item.date_end
                                  ? "по " + _vm.date_format(item.date_end)
                                  : ""
                              )
                          ),
                        ])
                      : _vm._e(),
                    item.annulled_type ||
                    item.annulled_date ||
                    item.annulled_type_termination ||
                    item.annulled_osnovanie
                      ? _c("p", { staticClass: "annulled" }, [
                          _vm._v(
                            _vm._s(
                              item.annulled_type ? item.annulled_type : ""
                            ) +
                              "\n " +
                              _vm._s(
                                item.annulled_date
                                  ? _vm.date_format(item.annulled_date)
                                  : ""
                              ) +
                              "\n " +
                              _vm._s(
                                item.annulled_type_termination
                                  ? "- " + item.annulled_type_termination
                                  : ""
                              ) +
                              "\n " +
                              _vm._s(
                                item.annulled_osnovanie
                                  ? "(" +
                                      item.annulled_osnovanie.toLowerCase() +
                                      ")"
                                  : ""
                              )
                          ),
                        ])
                      : _vm._e(),
                    _c("p", { staticClass: "manufacturer" }, [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            item.manufacturer_type
                              ? _vm.capitalize(item.manufacturer_type)
                              : "Изготовитель"
                          ) + ":"
                        ),
                      ]),
                      _vm._v(
                        "\n " +
                          _vm._s(
                            item.manufacturer_name ? item.manufacturer_name : ""
                          )
                      ),
                    ]),
                    item.applicant_vid
                      ? _c("p", { staticClass: "applicant" }, [
                          _c("b", [_vm._v("Вид заявителя:")]),
                          _vm._v(" " + _vm._s(item.applicant_vid)),
                        ])
                      : _vm._e(),
                  ]),
                  item_num < _vm.certificates.length ? _c("hr") : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          attrs: { slot: "footer", id: "certificates-modal-pagination" },
          slot: "footer",
        },
        [
          _vm.rowsCount > 100
            ? _c("old-pagination", {
                attrs: {
                  paginationObj: _vm.paginationObj,
                  getNewContent: _vm.changePage,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }